package nl.astraeus.wiki

import kotlinx.browser.document
import kotlinx.browser.window
import nl.astraeus.komp.Komponent
import nl.astraeus.wiki.service.OauthService
import nl.astraeus.wiki.service.WikiService
import nl.astraeus.wiki.view.MainView
import nl.astraeus.wiki.ws.WebsocketConnection

val mainView = MainView()

fun main() {
  Komponent.create(document.body!!, mainView)

  WebsocketConnection.open {
    if (window.location.pathname == "/oauth/google") {
      OauthService.handleGoogleOauth()
    } else {
      WikiService.retrieveWikiList()
    }
  }

}
